import { dataServerUrl } from '@/config/api';

// ---- 行政区划 ----

export interface AdminDivision {
  name: string;
  gid: number;
  [key: string]: any;
}

export async function fetchDistricts(name = '南京市', level = 2, gid: number | string = 140) {
  const url = dataServerUrl('selectXZQH', { name, level, gid: String(gid) });
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  const data = await res.json();
  return data.data as AdminDivision[];
}

export async function fetchStreets(name: string, level = 3, gid: number | string) {
  const url = dataServerUrl('selectXZQH', { name, level, gid: String(gid) });
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  const data = await res.json();
  return data.data as AdminDivision[];
}

// ---- 场景搜索 ----

export async function searchScenes(keyword: string) {
  const url = dataServerUrl('selectChangjing', { name: keyword });
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const result = await res.json();
  return result.data || result.rows || result || [];
}

// ---- 企业搜索 ----

export async function fetchEnterprisesBySceneId(
  gid: string | number,
  pageNum = 1,
  pageSize = 20,
) {
  const url = dataServerUrl('selectQYByCangJingId', {
    gid: String(gid),
    pageNum,
    pageSize,
  });
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const result = await res.json();
  const data = result.data || result.rows || result || [];
  const total = result.total ?? result.count ?? (Array.isArray(data) ? data.length : 0);
  return { data: Array.isArray(data) ? data : [], total };
}

export async function searchEnterprises(keyword: string) {
  const url = dataServerUrl('selectQYByKey', { name: keyword });
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const result = await res.json();
  return result.data || result.rows || result || [];
}

// ---- 动态图层（按 bounds 查询） ----

export interface Bounds {
  lonMin: number;
  latMin: number;
  lonMax: number;
  latMax: number;
}

export async function fetchDynamicLayer(endpoint: string, bounds: Bounds) {
  const url = dataServerUrl(endpoint, { ...bounds, length: 2 });
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  const data = await res.json();
  return data;
}

// ---- 场景面 / POI / 建筑物 ----

export interface SceneResult {
  buiList?: any[];
  poiList?: any[];
  LxList?: any[];
  [key: string]: any;
}

export async function fetchBuildingsByObjectId(objectid: string): Promise<SceneResult> {
  const url = dataServerUrl('selectIntersectByBounds_nanjing_bui_sByCJOBJECTID', { objectid });
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  const result = await res.json();
  return result.data || {};
}

export async function fetchRegionByGid(gid: string | number) {
  const url = dataServerUrl('selectIntersectByBounds_nanjing_cangjingByGid', { gid: String(gid) });
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const result = await res.json();
  const list = result.data || result.rows || result;
  return Array.isArray(list) ? list : [list];
}

export async function fetchScenesByTown(gid: string) {
  const url = dataServerUrl('selectCJByTown', { gid });
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  const data = await res.json();
  return data;
}

export async function fetchByWKT(wkt: string): Promise<SceneResult> {
  const url = dataServerUrl('selectByWKT', { wkt });
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  const data = await res.json();
  return data?.data || {};
}
